module.exports = __webpack_public_path__ + "static/media/README.3ac96da2.md";